<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('mentora_census_reports')" :is-filter="false">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('mentora_census_reports')" :is-filter="false">
                </HeaderMobile>
            </template>
            <div class="row data-form">
                <div class="col-12">
                    <ValidationObserver ref="form">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <ValidationProvider name="report" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('report')">
                                        <multi-selectbox :allow-empty="false" :multiple="false"
                                                         :validate-error="errors[0]" :options="reportOptions"
                                                         v-model="form.report"></multi-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-sm-6">
                                <ValidationProvider name="database" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('database')">
                                        <multi-selectbox :multiple="false" :validate-error="errors[0]" v-model="form.database" :options="databases">

                                        </multi-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-sm-6">
                                <ValidationProvider name="response_type" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('report_type')">
                                        <multi-selectbox :allow-empty="false"
                                                         :multiple="false"
                                                         :disabled="responseTypeDisabled"
                                                         :validate-error="errors[0]"
                                                         :options="responseTypeOptions"
                                                         v-model="form.response_type"></multi-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12">
                                <div class="row align-items-center">
                                    <div class="col-6" v-if="['1','3', '2', '4','5'].includes(form.report)">
                                        <ValidationProvider name="module_date_id"
                                                            :rules="['1','3','2','4','5'].includes(form.report)?'required':''"
                                                            v-slot="{valid, errors}">
                                            <b-form-group :label="$t('module_date')">
                                                <module-date-selectbox :validate-error="errors[0]" v-model="form.module_date_id"  :multiple="['3'].includes(form.report)">
                                                </module-date-selectbox>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <processing-button @click="send" label="get_report"
                                                       :processing="processing"></processing-button>
                                </div>
                            </div>

                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout"
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox";
import ProcessingButton from "@/components/elements/ProcessingButton";

import {reports as reportData} from '@/modules/eslCensusReports/data/data.js';
import EslReportService from "@/services/EslReportService";
import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";
import SettingsService from "@/services/SettingsService";
import qs from "qs";

export default {
    components: {
        ProcessingButton,
        MultiSelectbox,
        AppLayout,
        ValidationProvider,
        ValidationObserver,
        Header,
        HeaderMobile,
        ModuleDateSelectbox
    },
    metaInfo() {
        return {
            title: this.$t('mentora_census_reports')
        }
    },
    data() {
        return {
            responseTypeDisabled:false,
            form: {
                response_type: 'excel'
            },
            responseTypeOptions: [
                {value: 'page', text: this.$t('page')},
                {value: 'excel', text: this.$t('excel')},
                {value: 'pdf', text: 'PDF'},
            ],
            processing: false,
            reportName: "",
            databases: []
        }
    },
    created() {
        SettingsService.getCensusDatabases()
            .then(response => {
                let data = response.data.data
                this.databases = [];
                data.forEach(item => {
                    if(item.type!=='mentora'){
                        return;
                    }
                    this.databases.push({
                        text: item.name,
                        value: item.database
                    })
                })

            })

    },
    computed: {
        reportOptions() {
            return reportData.filter((item) => {
                return this.checkPermission(item.permission)
            })
        },
    },
    methods: {
        async send() {
            const isValid = await this.$refs.form.validate();
            if (isValid) {
                this.processing = true;
                this.reportName = this.getOptionText(this.reportOptions, this.form.report);
                let config = {
                    params: this.form,
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                    headers: {
                        'X-Census-Database': this.form.database
                    }
                };
                if (this.form.report === '4') {
                    config.params.program_code = '0702005';
                }

                if (this.form.report === '5') {
                    config.params.program_code = '0702002';
                }
                let isArrayBuffer = false;
                if (this.form.response_type != 'page') {
                    config.responseType = 'arraybuffer';
                    isArrayBuffer = true;
                }
                if (this.form.report == '1') {
                    EslReportService.reportsStudentCourseRegistration(config).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                } else if (this.form.report == '2') {
                    EslReportService.historyModuleReport(config).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                } else if (this.form.report == '3') {
                    EslReportService.agencyReport(config).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                }
                else if (this.form.report == '4') {
                    EslReportService.historyModuleReport(config).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                }
                else if (this.form.report == '5') {
                    EslReportService.historyModuleReport(config).then(this.callback).catch(e => {
                        this.showErrors(e, this.$refs.form, isArrayBuffer);
                    }).finally(() => {
                        this.processing = false;
                    });
                }
            }
        },
        callback(response) {
            if (this.form.response_type == 'page') {
                this._openFile(response);
            } else if (this.form.response_type == 'excel') {
                this._downloadFile(response, this.reportName + '.xlsx');
            } else if (this.form.response_type == 'pdf') {
                this._downloadFile(response, this.reportName + '.pdf');
            }
        },
    },
    watch: {
        'form.report'(newVal, oldVal) {
            if (newVal != oldVal) {
                this.form = {response_type: 'excel', report: newVal}
            }
            this.responseTypeDisabled=false
        },
        'form.response_type'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.form = {...this.form, response_type: newVal}
            }

        },
    },

};
</script>

